import { useStore } from '@modules';
import { FiatCurrencyEnum } from '@modules/global/types';

const useFiatCurrency = (): FiatCurrencyEnum => {
  const [{ global, user }] = useStore();
  const { data } = user;
  const { currencies } = global;
  const userFiatCurrency = data?.fiat_currency;

  return userFiatCurrency && currencies.fiat.includes(userFiatCurrency)
    ? userFiatCurrency
    : currencies.fiat[0] || CONST.defaultFiatCurrency;
};

export default useFiatCurrency;
